import Urls from '../urls.js';
import { fetcher } from '../../../../scripts/utils/fetch.js';
import BaseView from '../../../../scripts/utils/base-view.js';

export default class PrivateClientAdvisorView extends BaseView {
	constructor({
		el,
		init_chat
	}) {
		super(el);
		this.template_url = Urls.Templates.app;
		this.init_chat = init_chat;
		this.selectors = {
			liveChat: '.advisor-livechat'
		};
		this.advisor = null;
		this.fetchAdvisor();
	}

	fetchAdvisor() {

		fetcher(Urls.Api.customer.sales_profile, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json'
			}
		}).then( json => {
			this.advisor = json;
			if( !!this.advisor ) {
				this.calcRatingPercent();
				this.render();
			}
		});

	}

	get_context () {
		return {
			advisor: this.advisor
		};
	}

	after_render () {
		this.bindSelectors();
		this.bindLiveChat();
	}

	calcRatingPercent () {
		this.advisor.RatingPercent = !!this.advisor.Rating ? this.advisor.Rating / 5 * 100 : 0;
	}

	bindLiveChat () {
		if(this.init_chat && this.liveChatElement) {
			this.liveChatElement.addEventListener('click', this.init_chat);
		}
	}

}